var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnightWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6899 0.507025C31.0066 0.35897 32.3111 0.872519 33.1735 1.87839L41.3345 11.3969C50.7064 13.7129 56.1365 20.7699 59.1398 29.5797C62.2345 38.6575 63 50.182 63 62C63 64.2092 61.2092 66 59 66H21.7049C19.5814 66 17.828 64.3406 17.711 62.2203C17.6067 60.3281 18.042 57.045 19.3686 53.6915L19.393 53.6301C15.6257 55.6522 11.4448 55.1679 8.34115 52.9581C4.56929 50.2726 2.47204 45.0155 4.86818 39.8238C6.59606 36.0801 8.45835 34.0976 9.86715 32.5983C11.1831 31.1978 11.7315 30.5818 12.1195 29.0299C14.4717 19.6209 19.3109 14.2007 24.5079 11.7271C24.4327 10.6552 24.4939 9.62254 24.6253 8.68495C24.9526 6.35114 25.7673 4.19444 26.5978 2.61781C27.2153 1.44552 28.3732 0.655079 29.6899 0.507025Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1707 15.0185L30.1368 4.48193C28.8291 6.96453 27.5614 11.3461 29.384 14.5092C28.4994 14.588 27.6539 14.7376 27 15C22.8278 16.6743 18.25 21 16 30C15.3485 32.6061 14.1759 33.854 12.7822 35.3373C11.4675 36.7364 9.95621 38.3449 8.49999 41.5C5.49999 48 13.5963 54.5 19.5 48.5963C22.8191 45.2772 25.7204 43.907 28.1562 42.7566C31.662 41.1009 34.2036 39.9005 35.6393 34C36.3224 36.7523 36.0492 43.2477 29.4918 47.211C22.9344 51.1743 21.5683 59.5229 21.7049 62H59C59 38.4832 55.8865 18.1648 39.1707 15.0185Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 27,
    r: 3,
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnightWhite);
export default __webpack_public_path__ + "static/media/KnightWhite.6b88ea314a265bf997b717862ec4eee4.svg";
export { ForwardRef as ReactComponent };